module.exports = __webpack_public_path__ + "static/media/Background_Werde_Tutor_iPad.62000e25.svg";